<template>
  <div class="card-picker">
    <loading-overlay :is-loading="isLoading" />
    <v-row
      v-if="items.length"
      align="stretch"
    >
      <v-col
        v-for="(item, n) in items"
        :key="n"
        class="d-flex"
        cols="12"
        sm="6"
        lg="3"
      >
        <v-checkbox
          v-model="model"
          class="hide-checkbox-icon"
          :multiple="multiple"
          :value="item.value"
          :disabled="item.readonly"
        >
          <template #label>
            <card
              :id="item.value"
              :title="item.title"
              :info-dialog-title="item.title"
              :selected="isSelected(item.value)"
              :multiple="multiple"
              v-bind="item"
              @onInfoClick="$emit('onInfoClick', item)"
            />
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
    <h3 v-else>
      {{ notAvailableText }}
    </h3>
  </div>
</template>

<script>
  import Card from 'vue-flow-generator/src/components/Widgets/CheckboxCard'
  import { _ } from 'vue-underscore'
  import {VModel} from "@/mixins/VModel"
  import LoadingOverlay from "@/components/Overlays/LoadingOverlay"

  export default {
    name: "CardPicker",
    components: {
      Card,
      LoadingOverlay
    },
    mixins: [VModel],
    props: {
      items: {
        type: Array,
        required: true
      },
      multiple: {
        type: Boolean,
        default: false,
        description: "If multiple cards can be selected"
      },
      notAvailableText: {
        type: String,
        default: "No items to pick"
      },
      waitKeyword: {
        type: [String, undefined],
        default: undefined,
        description: "The $wait keyword to activate overlay loader."
      }
    },
    computed: {
      isLoading() {
        return this.waitKeyword !== undefined && this.$wait.is(this.waitKeyword)
      },
      isSelected() {
        return value => (this.multiple && _.contains(this.model, value)) || this.model === value
      },
    }
  }
</script>

<style lang="scss">
.progress {
  margin-top: 30px;
  margin-left: 50%;
}

.card-picker {

  .hide-checkbox-icon {
    padding: 0 1.5rem 0 0;
    .v-input--selection-controls__input {
      display: none;
    }
  }

  .v-input--selection-controls.v-input {
    margin: 0;
    padding: 0;
    flex: 1;
  }

  .v-input__slot {
    margin: 0;
  }

  .v-messages {
    min-height: 0;
  }

}
</style>
